import { TASK_TYPE_MODAL_MAP } from './constants'
import TaskModalWrapper from './customer/task/TaskModalWrapper'

import React, { useEffect, useState } from 'react'
import { useStore } from './store'
import { TASK_MODALS_ACTIONS } from './store/tasks'
import useAlert from './hooks/useAlert'
import useCustomer from './hooks/api/useCustomer'
import TaskTypeSelectorModal from './dashboard/TaskTypeSelectorModal'

const ModalListener = () => {
  const { state, dispatch } = useStore()

  const { createAlert } = useAlert()

  const close = () => {
    dispatch({ type: TASK_MODALS_ACTIONS.REMOVE_TASK_MODAL })
  }

  const {
    customer: customerData,
    isLoading,
    hasLoadError,
  } = useCustomer(task?.customerId, { skip: !!customer || !state.taskModal })

  const { task, customer, contact } = state.taskModal || {}

  const [currentOpenModal, setCurrentOpenModal] = useState(null)
  const [currentOpenModalStaging, setCurrentOpenModalStaging] = useState(null)
  const [selectedContact, setSelectedContact] = useState(null)
  const [selectedCustomer, setSelectedCustomer] = useState(null)

  useEffect(() => {
    if (!isLoading && !customer && customerData) {
      setSelectedCustomer(customerData)
    }
  }, [customerData, isLoading, customer])

  useEffect(() => {
    if (state.taskModal) {
      setCurrentOpenModal('selector')
      setCurrentOpenModalStaging(state.taskModal.task.taskTypeId)
      setSelectedContact(state.taskModal.contact)
      setSelectedCustomer(state.taskModal.customer)
    } else {
      setCurrentOpenModalStaging(null)
      setCurrentOpenModal(null)
      setSelectedContact(null)
      setSelectedCustomer(null)
    }
  }, [state.taskModal])

  if (!state.taskModal) return null

  const c = customer || customerData

  const Component = TASK_TYPE_MODAL_MAP[currentOpenModal]
  return (
    <>
      {Component && (
        <TaskModalWrapper
          Component={Component}
          isOpen
          onSave={(task) => {
            close()
            createAlert({ message: 'Successfully created task' })
          }}
          onClose={() => {
            close()
          }}
          task={null}
          customer={c}
          contact={contact}
        ></TaskModalWrapper>
      )}

      <TaskTypeSelectorModal
        currentOpenModal={currentOpenModal}
        currentOpenModalStaging={currentOpenModalStaging}
        setCurrentOpenModal={setCurrentOpenModal}
        setCurrentOpenModalStaging={setCurrentOpenModalStaging}
        selectedContact={selectedContact}
        setSelectedContact={setSelectedContact}
        selectedCustomer={selectedCustomer}
        setSelectedCustomer={setSelectedCustomer}
      />
    </>
  )
}

export default ModalListener
